export { ProjectDetails } from './ProjectDetails';
